import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EUniversity = {
  title: {
    name: ['تاریخ های اعزام', 'تاریخ های اعزام ها'],
  },
  // routes: PATH_DASHBOARD.university,
  api: api.dispatchDate,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EUniversity;
